import { useLocation, useNavigate } from 'react-router-dom';
import arrow from "../../src/assets/images/breadcrumbsArrow.png";

const Breadcrumbs = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Define all your pages in order
    const breadcrumbConfig = [
        { path: '/plan', label: 'Plans', route: '/plan' },
        { path: '/questionnaire', label: 'Questionnaire', route: '/questionnaire' },
        { path: '/goal', label: 'Goals', route: '/goal' },
        { path: '/swot', label: 'Swot', route: '/swot' },
        { path: '/medical', label: 'Theme', route: '/medical' },
        { path: '/finaltheme', label: 'Final Theme', route: '/finaltheme' },
        { path: '/tacticalplan', label: 'Tactical Plan', route: '/tacticalplan' },
        { path: '/ninetydayplan', label: 'Ninety Days Plan', route: '/ninetydayplan' },
        { path: '/onepageplan', label: 'One Page Plan', route: '/onepageplan' }
    ];

    // Find current page
    const currentPageIndex = breadcrumbConfig.findIndex(item =>
        location.pathname.includes(item.path)
    );

    return (
        <div
            className="main-breadcrumps px-4 py-4"
            style={{
                display: "flex",
                cursor: "pointer",
                alignItems: "center",
                gap: "5px",
            }}
        >
            {breadcrumbConfig.map((breadcrumb, index) => {
                const isCurrentPage = index === currentPageIndex;
                const isLastItem = index === breadcrumbConfig.length - 1;

                return (
                    <div key={breadcrumb.path} style={{ display: 'flex', alignItems: 'center' }}>
                        <p
                            className="breadCrumbs"
                            style={{
                                display: "flex",
                                fontWeight: isCurrentPage ? 'bold' : 'normal',
                                cursor: isCurrentPage ? 'default' : 'pointer'
                            }}
                            onClick={() => !isCurrentPage && navigate(breadcrumb.route)}
                        >
                            {breadcrumb.label}
                        </p>
                        {!isLastItem && (
                            <img className="arrowCrumbs" src={arrow} alt="" />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default Breadcrumbs;